export const REPORT_USER_REQUEST = 'user/REPORT_REQUEST';
export const REPORT_USER_SUCCESS = 'user/REPORT_SUCCESS';
export const REPORT_USER_FAILURE = 'user/REPORT_FAILURE';

export const reportUserRequest = () => ({ type: REPORT_USER_REQUEST });
export const reportUserSuccess = payload => ({ type: REPORT_USER_SUCCESS, payload });
export const reportUserFailure = () => ({ type: REPORT_USER_FAILURE });

export function reportUser(report = {}) {
  return (dispatch, getState, { request }) => {
    dispatch(reportUserRequest());

    const promise = request.post(`/_api/users/${report._id}/report`, { reportType: report.reportType });

    return promise
      .then(() => dispatch(reportUserSuccess({ _id: report._id })))
      .catch(() => dispatch(reportUserFailure()))
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/report-user.js